import { __assign } from "tslib";
import { styled, AppBar as MuiAppBar } from '@mui/material';
export var StyledAppBar = styled(MuiAppBar, {
    shouldForwardProp: function (prop) { return !['htmlColor'].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme, color = _a.color, htmlColor = _a.htmlColor;
    return (__assign({}, (htmlColor && {
        backgroundColor: htmlColor,
    })));
});
//# sourceMappingURL=styled.js.map